import { Directive, Input, Output, EventEmitter, ElementRef, AfterViewInit } from '@angular/core';
import { environment } from '../../environments/environment';

declare var jQuery: any;
@Directive({
  selector: '[appAutocomplete]',
})
export class AutocompleteDirective implements AfterViewInit {
  /**
   * URL to use for autocomplete search
   * @param {[type]} 'appAutocomplete' variable name
   */
  @Input('appAutocomplete') autocompleteURL: string;

  /**
   * Additional data to be sent on autocomplete search to the URL
   */
  @Input() data: any = {};

  /**
   * Indicates that the selected item is to be returned as it is
   */
  @Input() include_name: boolean = false;

  /**
   * Indicates that the selected item is to be returned as it is
   */
  @Input() include_item: boolean = false;

  /**
   * Minimum number of characters before autocomplete fires
   */
  @Input() minLength: number = 3;

  /**
   * Output user selection
   * @param {EventEmitter<any> = new EventEmitter(} ) autocompleteSelect [description]
   */
  @Output() autocompleteSelect: EventEmitter<any> = new EventEmitter();

  private initialized: boolean = false;

  /**
   * Constructor
   * @param {ElementRef} private el Reference to element where the directive is used
   */
  constructor(private el: ElementRef) {}

  /**
   * Called after view is initialized, used to initialize the autocomplete search once
   */
  ngAfterViewInit(): void {
    if (this.initialized) return;
    this.initialized = true;

    let autocompleteElement = jQuery(this.el.nativeElement);
    let scope = this;
    let autocompleteUrl: string = this.autocompleteURL;
    if(environment.url && environment.url.indexOf(window.location.origin) < 0) {
      autocompleteUrl = `${environment.url}${autocompleteUrl}`;
    }
    // Append to parent when inside a modal or scrollable container to prevent clipping
    let appendTarget = null;
    if (autocompleteElement.closest('.modal').length) {
      appendTarget = autocompleteElement.parent();
    } else if (autocompleteElement.closest('[style*="overflow"]').length) {
      appendTarget = autocompleteElement.parent();
    }
    autocompleteElement.autocomplete({
      autoFocus: true,
      minLength: scope.minLength,
      appendTo: appendTarget,
      select: function (event: any, ui: any) {
        if (scope.include_name || scope.include_item) scope.autocompleteSelect.emit(ui.item);
        else scope.autocompleteSelect.emit(ui.item.id);
      },
      source: function (request: any, response: any) {
        scope.data.term = request.term;
        let token: string | null = window.localStorage.getItem('token');
        let headers: any = { Accept: "application/json", Authorization: `Bearer ${token}` };
        jQuery.ajax({
          url: `${autocompleteUrl}.json`,
          data: scope.data,
          success: (data: any) => {
            // Ensure items have label property for jQuery UI autocomplete
            const items = Array.isArray(data) ? data.map((item: any) => ({
              ...item,
              label: item.label || item.name || item.display_name || item.value || String(item.id),
              value: item.value || item.label || item.name || item.display_name || String(item.id)
            })) : data;
            response(items);
          },
          dataType: 'json',
          headers: headers
        });
      },
    });
  }
}
